import {routes} from './network.routes';
import NetworkListController from "./directory/directory.controller";
import NetworkService from "./network.service";
import NetworkDetailsController from "./details/details.controller";

export default angular.module('app.network', [])
  .config(routes)
  .controller('NetworkListController', NetworkListController)
  .service('NetworkService', NetworkService)
  .controller('NetworkDetailsController', NetworkDetailsController)
  .name;
